module.exports = Backbone.Model.extend({
	url: function() {
		return App.apiRoot + 'acl/' + this.id
	}
})
